import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';

import {
  createZeeFinancial,
  CreateZeeFinancialApiPayload,
} from '@/actions/zee-financial/createZeeFinancial';
import { GetZeeFinancialApiResponse } from '@/actions/zee-financial/getZeeFinancial';
import { ApiResponse } from '@/types/response.type';

export interface UseCreateZeeFinancialReturn {
  mutate: (
    payload: CreateZeeFinancialApiPayload
  ) => Promise<ApiResponse<GetZeeFinancialApiResponse> | undefined>;
  result: ApiResponse<GetZeeFinancialApiResponse> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useCreateZeeFinancial = (): UseCreateZeeFinancialReturn => {
  const queryClient = useQueryClient();

  const mutation: UseMutationResult<
    ApiResponse<GetZeeFinancialApiResponse> | undefined,
    Error,
    CreateZeeFinancialApiPayload
  > = useMutation({
    mutationFn: createZeeFinancial,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['zee-financial'] });
    },
  });

  return {
    mutate: mutation.mutateAsync,
    result: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isPending,
  };
};
